import * as React from 'react';

import { Vanilla, VanillaAside, VanillaMain } from '@/layouts/Vanilla';

import { OnboardingChecklist } from '../../imports/ui/components/OnboardingChecklist';
import { GroupSectionPageContent } from './components/GroupSectionPageContent';

export const GroupSectionPage: React.FC = () => {
  return (
    <Vanilla>
      <VanillaMain>
        <GroupSectionPageContent />
      </VanillaMain>
      <VanillaAside>
        <OnboardingChecklist />
      </VanillaAside>
    </Vanilla>
  );
};
